import { render, staticRenderFns } from "./VisitaAngiologicaList.vue?vue&type=template&id=24f24ee4"
import script from "./VisitaAngiologicaList.vue?vue&type=script&lang=js"
export * from "./VisitaAngiologicaList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports